/*
 * =============================================
 * ✅ 스마트캡 주문 설정 - 가격/색상/계좌 변경
 * =============================================
 * 아래 항목만 수정하면 전체 자동 반영됩니다.
 *
 * prices     : 제품유형별 봉당 단가 (원)
 * orderTypes : 주문 유형 목록 (prices 키와 일치해야 함)
 * colors     : 색상 선택 옵션 목록
 * unit       : 수량 단위 표시
 * deliveryFee: 배송비 (원)
 * bankInfo   : 무통장 입금 계좌 정보
 * =============================================
 */

// ✅ 가격 및 설정 변경은 이 블록에서만 하세요
export const PRODUCT_CONFIG = {
  prices: {
    '대골': 0,    // ← 이 숫자만 바꾸면 가격 변경
    '소골': 0,    // ← 이 숫자만 바꾸면 가격 변경
    '원형캡': 0,  // ← 이 숫자만 바꾸면 가격 변경
  } as Record<string, number>,

  orderTypes: ['대골', '소골', '원형캡'] as string[],

  colors: [
    '청색', '은회색', '밤색', '녹색',
    '아이보리', '오렌지색', '진녹색', '흑색',
  ] as string[],

  unit: '봉',         // 단위 표시

  deliveryFee: 3000,  // 배송비 (원)

  bankInfo: {
    bank: '농협은행',
    account: '351-0918-8977-03',
    holder: '김경원',
  },
} as const;

/* ─── localStorage 키 ─────────────────────────────────── */
const LS_KEY = 'smartcap_admin_prices';

/* ─── 런타임 config 로드 (localStorage 우선) ─────────── */
export interface RuntimeConfig {
  prices: Record<string, number>;
  orderTypes: string[];
  colors: string[];
  unit: string;
  deliveryFee: number;
  bankInfo: { bank: string; account: string; holder: string };
}

export function loadConfig(): RuntimeConfig {
  const base: RuntimeConfig = {
    prices: { ...PRODUCT_CONFIG.prices },
    orderTypes: [...PRODUCT_CONFIG.orderTypes],
    colors: [...PRODUCT_CONFIG.colors],
    unit: PRODUCT_CONFIG.unit,
    deliveryFee: PRODUCT_CONFIG.deliveryFee,
    bankInfo: { ...PRODUCT_CONFIG.bankInfo },
  };

  try {
    const saved = localStorage.getItem(LS_KEY);
    if (saved) {
      const parsed = JSON.parse(saved) as Partial<RuntimeConfig>;
      if (parsed.prices) base.prices = { ...base.prices, ...parsed.prices };
      if (typeof parsed.deliveryFee === 'number') base.deliveryFee = parsed.deliveryFee;
      if (parsed.bankInfo) base.bankInfo = { ...base.bankInfo, ...parsed.bankInfo };
    }
  } catch {
    // localStorage 파싱 실패 시 기본값 사용
  }

  return base;
}

export function saveAdminPrices(
  prices: Record<string, number>,
  deliveryFee: number,
  bankInfo: { bank: string; account: string; holder: string }
): void {
  localStorage.setItem(LS_KEY, JSON.stringify({ prices, deliveryFee, bankInfo }));
}

export function resetAdminPrices(): void {
  localStorage.removeItem(LS_KEY);
}
